import { FlowDefinitionModel } from '../Models/FlowModel';
import { isSchemaValueReference, SchemaValueBindingModel, SchemaValueModel } from '../Models/SchemaValueModel';

export function resolveFlowSchemaValue(
	flow: Pick<FlowDefinitionModel, 'SchemaValues'> | undefined,
	binding: SchemaValueBindingModel | undefined,
): SchemaValueModel | undefined {
	if (!binding) return undefined;
	if (!isSchemaValueReference(binding)) return binding;
	return flow?.SchemaValues?.find((schema) => schema.Id === binding.SchemaValueId);
}

export function upsertFlowSchemaValue(flow: FlowDefinitionModel, schema: SchemaValueModel): FlowDefinitionModel {
	const schemas = flow.SchemaValues ?? [];
	return {
		...flow,
		SchemaValues: schemas.some((item) => item.Id === schema.Id)
			? schemas.map((item) => item.Id === schema.Id ? schema : item)
			: [...schemas, schema],
	};
}

export function countFlowSchemaUses(
	flow: FlowDefinitionModel,
	activities: { data: Record<string, unknown> }[],
): ReadonlyMap<string, number> {
	const counts = new Map<string, number>();
	const count = (value: unknown) => {
		if (value && typeof value === 'object' && 'SchemaValueId' in value && typeof value.SchemaValueId === 'string') {
			counts.set(value.SchemaValueId, (counts.get(value.SchemaValueId) ?? 0) + 1);
		}
	};
	count(flow.InputSchemaValue);
	count(flow.OutputSchemaValue);
	for (const activity of activities) {
		for (const value of Object.values(activity.data)) count(value);
	}
	return counts;
}
